import { render, staticRenderFns } from "./UserSettings.vue?vue&type=template&id=af05c3c8&scoped=true&"
import script from "./UserSettings.vue?vue&type=script&lang=js&"
export * from "./UserSettings.vue?vue&type=script&lang=js&"
import style0 from "./UserSettings.vue?vue&type=style&index=0&id=af05c3c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af05c3c8",
  null
  
)

export default component.exports